import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import CopyCitationNotificationEditing from './copycitationnotificationediting';

export default class CopyCitationNotification extends Plugin {
  static get requires() {
    return [ CopyCitationNotificationEditing ];
  }

  static get pluginName() {
    return 'CopyCitationNotification';
  }
}
